import { LogOut, ShieldAlert } from "lucide-react";

import { useStopImpersonation } from "@/api/queries/auth";
import type { ImpersonationState } from "@/api/types";
import { Button } from "@/components/ui";

/** Persistent, unmistakable banner while a platform administrator acts as someone else. */
export function ImpersonationBanner({ impersonation }: { impersonation: ImpersonationState }) {
  const stop = useStopImpersonation();
  return (
    <section
      aria-label="Impersonation"
      className="flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 border-b-2 border-warning bg-warning-subtle px-4 py-1.5 text-sm text-warning-text"
    >
      <ShieldAlert aria-hidden className="size-4 shrink-0" />
      <p className="min-w-0 flex-1">
        <strong className="font-semibold">Impersonating {impersonation.target_name}</strong>{" "}
        <span className="opacity-90">
          ({impersonation.target_email}) in <strong className="font-semibold">{impersonation.tenant_name}</strong>. Actions are recorded as
          support actions by {impersonation.actor_email}.
        </span>
      </p>
      <Button size="sm" variant="secondary" icon={<LogOut aria-hidden className="size-3.5" />} loading={stop.isPending} onClick={() => stop.mutate()}>
        Exit impersonation
      </Button>
    </section>
  );
}
